const horseListContainer = document.querySelector("#horse-list-container");
const horseTeaser = document.querySelectorAll(".horse-teaser-card.horse-teaser-card-list");
const horseFilter = document.querySelector(".horse-list-filter");
const horseSearch = document.querySelector(".horse-list-search");
const horseEmptySeachText = document.querySelector("#horse-list-view-empty");
const switchAlphanumericOrderButton = document.querySelector("#horse-list-switch-alphanumeric-order-button");
const horseSellTypeFilter = document.querySelector("#horse-list-filter-selltype");

if (horseTeaser) {
    scale_horseTeaserCards();
}

function scale_horseTeaserCards() {
    let height = 0;
    horseTeaser.forEach((item) => {
        const elementHeight =
            item.offsetHeight -
            parseFloat(getComputedStyle(item).paddingTop) -
            parseFloat(getComputedStyle(item).paddingBottom);
        if (elementHeight > height) {
            height = elementHeight;
        }
    });

    horseTeaser.forEach((item) => {
        const teaserCardImage = item.querySelector(".horse-teaser-card__content-image img");
        const teaserCardImageHeight = teaserCardImage?.offsetHeight || 0;
        const teaserCardText = item.querySelector(".horse-teaser-card__content-text");
        teaserCardText.style.height = height - teaserCardImageHeight + "px";
    });
}

if (horseFilter && horseTeaser && horseSearch) {
    horseEmptySeachText.style.display = "none";
    const preFilter = horseFilter?.getAttribute("activefilter") || "all";
    let activeFilter = preFilter;
    let activeSearch = "";
    let activeTypeFilter = "fresh";
    let ordererdASC = true;
    let lastActiveTypeFilter = "fresh";

    if (switchAlphanumericOrderButton) {
        switchAlphanumericOrderButton.addEventListener("click", (e) => {
            for (var i = 1; i < horseListContainer.childNodes.length; i++) {
                horseListContainer.insertBefore(horseListContainer.childNodes[i], horseListContainer.firstChild);
            }
            ordererdASC = !ordererdASC;
            const buttonIcon = switchAlphanumericOrderButton.querySelector(".filter-button-icon");
            const buttonText = switchAlphanumericOrderButton.querySelector(".filter-button-text");
            const ascText = switchAlphanumericOrderButton.dataset.translationasc;
            const descText = switchAlphanumericOrderButton.dataset.translationdesc;
            if (ordererdASC) {
                buttonIcon.classList.remove("icon-sort-descending");
                buttonIcon.classList.add("icon-sort-ascending");
                buttonText.innerText = ascText;
            } else {
                buttonIcon.classList.add("icon-sort-descending");
                buttonIcon.classList.remove("icon-sort-ascending");
                buttonText.innerText = descText;
            }
        });
    }

    if (horseSellTypeFilter) {
        horseSellTypeFilter.addEventListener("change", (e) => {
            activeTypeFilter = e.target.value;
            lastActiveTypeFilter = activeTypeFilter;
            filterHorseteaser();
        });
    }

    horseFilter?.addEventListener("change", (e) => {
        activeFilter = e.target.value;
        if (activeFilter != "stallion") activeTypeFilter = "";
        checkHorseFilter();
        filterHorseteaser();
    });

    horseSearch?.addEventListener("input", (e) => {
        activeSearch = e.target.value;
        filterHorseteaser();
    });

    horseFilter.value = activeFilter;
    checkHorseFilter();
    filterHorseteaser();

    function filterHorseteaser() {
        let searchCount = 0;
        horseTeaser.forEach((teaser) => {
            let horseCat = teaser.getAttribute("data-horse-category");
            let horseName = teaser.getAttribute("data-horse-name");
            let horseType = teaser.getAttribute("data-horse-type");
            if (horseName === "" || horseName === null) {
                teaser.style.display = "none";
                return;
            }

            if (
                (activeFilter == horseCat || activeFilter == "all") &&
                (activeTypeFilter == horseType || activeTypeFilter == "")
            ) {
                if (horseName.toLowerCase().includes(activeSearch.toLowerCase()) || activeSearch == "") {
                    searchCount++;
                    teaser.style.display = "block";
                } else {
                    teaser.style.display = "none";
                }
            } else {
                teaser.style.display = "none";
            }
        });

        if (searchCount == 0) {
            horseEmptySeachText.style.display = "block";
        } else {
            horseEmptySeachText.style.display = "none";
        }
    }

    function checkHorseFilter() {
        if (activeFilter == "stallion") {
            horseSellTypeFilter.style.display = "block";
            activeTypeFilter = lastActiveTypeFilter;
        } else {
            horseSellTypeFilter.style.display = "none";
            activeTypeFilter = "";
        }
    }
}
